import { operatorApiFetch } from './apiService';

export const valueAddedServiceService = {
  // 搜尋列表 (游標分頁，用於 Select)
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.since_id) queryParams.append('since_id', params.since_id);
    if (params.direction) queryParams.append('direction', params.direction);

    const response = await operatorApiFetch(`value_added_services?${queryParams.toString()}`, {
      method: 'GET'
    });
    return response.json();
  },

  // 列表（表格分頁）
  getRecords: async (params) => {
    const response = await operatorApiFetch('value_added_services/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('value_added_services/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取單個加值服務
  get: async (id) => {
    const response = await operatorApiFetch(`value_added_services/${id}`, {
      method: 'GET'
    });
    return response.json();
  },

  // 建立加值服務
  create: async (data) => {
    // 前端使用 merchant_id 帶入 current_operator_merchant
    const response = await operatorApiFetch(`value_added_services?merchant_id=${data.merchant_id}`, {
      method: 'POST',
      body: JSON.stringify({ value_added_service: data })
    });
    return response.json();
  },

  // 更新加值服務
  update: async (id, data) => {
    const response = await operatorApiFetch(`value_added_services/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ value_added_service: data })
    });
    return response.json();
  },

  // 刪除加值服務
  destroy: async (id) => {
    const response = await operatorApiFetch(`value_added_services/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};

export default valueAddedServiceService;
